import { FC } from 'react';
import { CompanyDetails } from 'containers/companies';
import { Stack } from '@mui/material';
import {
  Loader,
  NothingFoundAlert,
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useCompany } from 'store/companies';
import { useRouteParams } from 'utils/useIdParam';
import { useRouteMatch } from 'react-router-dom';
import { useMe } from 'state/Administrators';
import { useTranslation } from 'react-i18next';

const CompanyDetailsPage: FC = () => {
  const { t } = useTranslation();
  const { me } = useMe();
  const { path } = useRouteMatch();
  const { id: companyId } = useRouteParams(ROUTES.companies.details);

  const { data: company, isLoading } = useCompany(companyId);

  if (companyId && isLoading) return <Loader />;
  if (companyId && !company) return <NothingFoundAlert />;

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: me?.parentCompany
              ? `${me.parentCompany.name} (${t('marketplace.employeeID', {
                  id: me.parentCompany.id,
                })})`
              : '',
            url: '/more/company-settings',
          },
          {
            label: t('sidebar.companies'),
            url: '/more/company-settings?tab=companySettingsCompanies',
          },
          {
            label: !companyId
              ? t('companies.new_company')
              : isLoading
              ? ''
              : company?.name ?? '',
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'settings',
                label: t('common.settings'),
                url: companyId
                  ? ROUTES.companies.details.replace(':id', companyId)
                  : ROUTES.companies.create,
                isActive:
                  path === ROUTES.companies.details ||
                  path === ROUTES.companies.create,
              },
            ]}
          />
        }
      >
        <CompanyDetails />
      </PageContentLayout>
    </Stack>
  );
};

export default CompanyDetailsPage;
